import React from 'react'
import '../CSS/Udistay.css';

const Udistay = () => {

return (

  <div className='Udistay-Container'>

    <h3 className='Udistay-heading'><span>आमची</span>उद्दिष्ट्य</h3>

    <div className='Mukhya-Udistay'>
      <h3>मुख्य उद्दिष्टे  :</h3> <h6>"जगात एक तरी गाव असावं, जिथे कविता श्वास घेते."</h6>
    </div>
<div className='Udistay-data'>

  <div className='data-cont'>
    <h4 className='data-head'>१.सामाजिक आणि सांस्कृतिक जोडणी  :</h4>
    <p className='data-info'><span>"ग्रंथदिंडी" -</span>गावभर कवितांच्या ग्रंथांची मिरवणूक आणि वाचन उपक्रम</p>
    <p className='data-info'><span> "स्त्रीसन्मान आणि कविता" -</span> महिला कवींना विशेष मंच</p>
    <p className='data-info'><span>"शेतकऱ्यांसाठी कविता" -</span> शेती, निसर्ग आणि ग्रामीण जीवनावर आधारित विशेष काव्य संमेलन </p>
    <p className='data-info'><span>"कविता आणि पर्यावरण" उपक्रम  -</span>वृक्षारोपण, निसर्ग कविता लेखन आणि प्रदर्शन</p>

  </div>
 
 
  <div className='data-cont'>
    <h4 className='data-head'>२.साहित्य पर्यटन आणि जकातवाडीचा काव्य विकास
    :</h4>
    <p className='data-info'><span>"कविता भिंती" -</span> गावातील प्रमुख ठिकाणी आकर्षक काव्य भिंती रंगवणे</p>
    <p className='data-info'><span>"काव्य शिल्प आणि चौक" -</span>गावात विशिष्ट ठिकाणी कविता शिल्प उभारणे</p>
    <p className='data-info'><span>“राष्ट्रीय आणि आंतरराष्ट्रीय कवींसाठी निमंत्रण" -</span>  मोठ्या साहित्यिकांना गावाला भेट देण्यासाठी आमंत्रित करणे </p>
    <p className='data-info'><span>"काव्य पर्यटन योजना" -</span>गावाला भेट देणाऱ्या पर्यटकांसाठी कविता संमेलन आयोजित करणे</p>

  </div>
 


  <div className='data-cont'>
    <h4 className='data-head'>३.  डिजिटल आणि माध्यमांचा वापर :
    </h4>
    <p className='data-info'><span>"ऑनलाइन काव्य संमेलन" -</span> फेसबुक, यूट्यूब, आणि व्हॉट्सअॅपवर कवितांचे सादरीकरण</p>
    <p className='data-info'><span>"गावाच्या कवितांचा पॉडकास्ट आणि व्हिडीओ डॉक्युमेंटरी"</span></p>
    
    <p className='data-info'><span>"माझं कवितांचं गाव" -</span> संकेतस्थळ अद्ययावत करणे आणि त्यावर कवितांचे संकलन अपलोड करणे </p>

  </div>


  <div className='data-cont'>
    <h4 className='data-head'>४. वाचनालय आणि पुस्तकसंस्कृतीचा विकास :
    </h4>
    <p className='data-info'><span>"ग्रंथ तुमच्या दारी" उपक्रम" -</span>घरोघरी पुस्तके पोहोचवणे</p>
    <p className='data-info'><span>"एक गाव - एक काव्य ग्रंथ" -</span> उपक्रम वर्षभर गावाने एक कविता संग्रह वाचण्याची संकल्पना </p>
    <p className='data-info'><span>"पुस्तक प्रदर्शने आणि विक्री" -</span>  गावातील आणि बाहेरील प्रकाशनसंस्थांबरोबर सहकार्य करून आयोजन </p>
  
  </div>


</div>



    



  </div>






)







}
export default Udistay;